<template>
  <div class="-mb-4">
    <div class="flex items-baseline mb-4">
      <template v-if="facebookCampaign">
        <header>
          <h5 class="text-xs text-gray-600 font-normal uppercase">Facebook Campaign</h5>
          <h3 class="text-base">
            {{ facebookCampaign.name }}
          </h3>
        </header>
        <span
          :class="{
            'inline-block': true,
            'bg-green-200': facebookCampaign.status === 'ACTIVE',
            'bg-gray-200': facebookCampaign.status !== 'ACTIVE',
            'px-3': true,
            'py-1': true,
            'leading-snug': true,
            rounded: true,
            'text-xs': true,
            'text-green-900': facebookCampaign.status === 'ACTIVE',
            'text-gray-900': facebookCampaign.status !== 'ACTIVE',
            capitalize: true,
            'font-medium': true,
            'select-none': true,
            'ml-auto': true,
          }"
        >
          {{ facebookCampaign.status }}
        </span>
      </template>
      <h3 v-else class="text-base mr-auto">Δεν υπάρχει συνδεδεμένη καμπάνια Facebook</h3>

      <slot />
    </div>

    <template v-if="facebookCampaign">
      <div class="list list-spaced rounded-t-none border-0 -mx-4">
        <FacebookCampaignInsight
          period="Lifetime"
          :impressions="aggregatedInsights.impressions"
          :reach="aggregatedInsights.reach"
          :frequency="aggregatedInsights.frequency"
          :inline-link-clicks="aggregatedInsights.inline_link_clicks"
          class="text-lg"
        />

        <FacebookCampaignInsightHeader />

        <template v-if="shouldDisplayMore">
          <FacebookCampaignInsight
            v-for="(data, idx) in insights"
            :key="idx"
            :period="data.date_start"
            :impressions="data.impressions"
            :reach="data.reach"
            :frequency="data.frequency"
            :inline-link-clicks="data.inline_link_clicks"
          />
        </template>

        <a
          v-if="insights.length"
          role="button"
          class="px-4 block hover:bg-gray-100 focus:outline-none text-center"
          @click="toggleMore"
        >
          Show {{ shouldDisplayMore ? 'less' : 'more' }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { sumBy, meanBy } from 'lodash-es';
import FacebookCampaignInsightHeader from './FacebookCampaignInsightHeader.vue';
import FacebookCampaignInsight from './FacebookCampaignInsight.vue';

export default {
  components: {
    FacebookCampaignInsightHeader,
    FacebookCampaignInsight,
  },
  props: {
    facebookCampaign: { type: Object, default: () => null },
  },
  data: () => ({
    shouldDisplayMore: false,
  }),
  computed: {
    insights() {
      return this.facebookCampaign?.facebook_campaign_insights || [];
    },
    aggregatedInsights() {
      return {
        impressions: sumBy(this.insights, 'impressions'),
        reach: sumBy(this.insights, 'reach'),
        frequency: meanBy(this.insights, 'frequency'),
        inline_link_clicks: sumBy(this.insights, 'inline_link_clicks'),
      };
    },
  },
  methods: {
    toggleMore() {
      this.shouldDisplayMore = !this.shouldDisplayMore;
    },
  },
};
</script>
